module.exports = __webpack_public_path__ + "media/images/arrow-down-01b7fab5.svg";